import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  addTransactionFailure,
  //
  addTransactionSuccess,
  createPaymentFailure,
  //
  createPaymentSuccess,
  fetchPackagesFailure,
  fetchPackagesSuccess,
} from "./actions";
import { ADD_TRANSACTION, CREATE_PAYMENT, FETCH_PACKAGES } from "./constants";

export function* fetchPackagesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/package?${query}`);
    yield put(fetchPackagesSuccess(data));
  } catch (e) {
    yield put(fetchPackagesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching packages!"));
  }
}

export function* createIntentSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/create-payment-intent`,
      payload
    );
    yield put(createPaymentSuccess(data));
  } catch (e) {
    yield put(createPaymentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while creating payment!"));
  }
}

export function* addTransactionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/credit-history/add`,
      payload
    );
    yield put(addTransactionSuccess(data));
  } catch (e) {
    yield put(addTransactionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while creating payment!"));
  }
}

export function* fetchPackagesFlow() {
  yield takeEvery(FETCH_PACKAGES, fetchPackagesSaga);
}
export function* createIntentFlow() {
  yield takeEvery(CREATE_PAYMENT, createIntentSaga);
}
export function* addTransactionFlow() {
  yield takeEvery(ADD_TRANSACTION, addTransactionSaga);
}

export default function* PackageSaga() {
  yield all([fetchPackagesFlow(), createIntentFlow(), addTransactionFlow()]);
}
